import React from "react";
import { Button, Typography } from "@mui/material";
import styled from "@emotion/styled";

const StyledTabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "activeColor",
})(({ theme, active, activeColor }) => ({
  width: "100%",
  padding: "12px 12px",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: "bold",
  transition: "all 0.3s ease",
  ...(active
    ? {
        backgroundColor: activeColor,
        color: "white",
        boxShadow: `0 4px 12px -2px ${activeColor}99`,
        "&:hover": {
          backgroundColor: activeColor,
          transform: "translateY(-2px)",
        },
      }
    : {
        backgroundColor: "#e2e8f0",
        color: "#334155",
        "&:hover": {
          backgroundColor: "#cbd5e1",
          transform: "translateY(-2px)",
        },
      }),
}));

const CountBadge = styled("span", {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
  backgroundColor: active ? "rgba(255,255,255,0.2)" : "#cbd5e1",
  color: active ? "white" : "#334155",
  padding: "2px 8px",
  borderRadius: "12px",
  fontSize: "0.75rem",
  marginLeft: "8px",
}));

export const TabButton = ({ label, count, isActive, onClick, activeColor }) => {
  return (
    <StyledTabButton
      active={isActive}
      onClick={onClick}
      activeColor={activeColor}
    >
      <Typography variant="body2" component="span" fontWeight="bold">
        {label}
      </Typography>
      <CountBadge active={isActive}>{count}</CountBadge>
    </StyledTabButton>
  );
};
